import e, { Component as t } from "react";
import o from "react-dom";
import { InputText as i } from "../InputText/InputText.js";
import r from "../../../../node_modules/classnames/index.js";
import n from "../../../utils/ObjectUtils.js";
import { FormLabel as s } from "../Label/FormLabel.js";
import { Icon as l } from "../../general/Icon/Icon.js";
import a from "../../../utils/DomHandler.js";
import { AutoCompletePanel as p } from "./AutoCompletePanel.js";
import { tip as u } from "../Tooltip/Tooltip.js";
import c from "../../../utils/UniqueComponentId.js";
import d from "../../../utils/ConnectedOverlayScrollHandler.js";
import { Spinner as h } from "../../loaders/Spinner/Spinner.js";
import m from "../../../../node_modules/react-transition-group/esm/CSSTransition.js";
function f(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var o = 0, i = Array(t); o < t; o++) i[o] = e[o];
  return i;
}
function v(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function y(e, t) {
  for (var o = 0; o < t.length; o++) {
    var i = t[o];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function g(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function b(e) {
  return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function k(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {},
      i = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), i.forEach(function (t) {
      g(e, t, o[t]);
    });
  }
  return e;
}
function C(e, t) {
  return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function (e, t) {
    var o = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      o.push.apply(o, i);
    }
    return o;
  }(Object(t)).forEach(function (o) {
    Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
  }), e;
}
function O(e, t) {
  return (O = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function w(e) {
  return function (e) {
    if (Array.isArray(e)) return f(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return f(e, t);
      var o = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o) return Array.from(o);
      if ("Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return f(e, t);
    }
  }(e) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var I = function I() {},
  E = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && O(e, t);
    }(x, t);
    var f,
      E,
      _,
      S = (f = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          o = b(x);
        if (f) {
          var i = b(this).constructor;
          t = Reflect.construct(o, arguments, i);
        } else t = o.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : v(this);
      });
    function x(e) {
      var t;
      return !function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, x), g(v(t = S.call(this, e)), "id", void 0), g(v(t), "listId", void 0), g(v(t), "timeout", void 0), g(v(t), "inputEl", void 0), g(v(t), "ariaSelected", void 0), g(v(t), "overlay", void 0), g(v(t), "multiContainer", void 0), g(v(t), "documentClickListener", void 0), g(v(t), "resizeListener", void 0), g(v(t), "scrollHandler", void 0), g(v(t), "container", void 0), g(v(t), "tooltip", void 0), g(v(t), "state", {
        searching: !1,
        focused: !1,
        overlayVisible: !1
      }), g(v(t), "onInputChange", function (e) {
        t.timeout && clearTimeout(t.timeout);
        var o = e.target.value;
        t.props.multiple || t.updateModel(e, o), 0 === o.length ? (t.hideOverlay(), t.props.onClear && t.props.onClear(e)) : o.length >= t.props.minLength ? t.timeout = setTimeout(function () {
          t.search(e, o, "input");
        }, t.props.delay) : t.hideOverlay();
      }), g(v(t), "selectItem", function (e, o) {
        if (t.props.multiple) {
          if (t.inputEl.value = "", !t.isSelected(o)) {
            var i;
            i = t.props.value && Array.isArray(t.props.value) ? w(t.props.value).concat([o]) : [o], t.updateModel(e, i);
          }
        } else t.updateInputField(o), t.updateModel(e, o);
        t.props.onSelect && t.props.onSelect({
          originalEvent: e,
          value: o
        }), t.inputEl.focus(), t.hideOverlay();
      }), g(v(t), "onOverlayEnter", function () {
        t.overlay.itemsWrapper.style.zIndex = String(a.generateZIndex()), t.alignOverlay();
      }), g(v(t), "onOverlayEntered", function () {
        t.bindDocumentClickListener(), t.bindScrollListener(), t.bindResizeListener();
      }), g(v(t), "onOverlayExit", function () {
        t.unbindDocumentClickListener(), t.unbindScrollListener(), t.unbindResizeListener();
      }), g(v(t), "onDropdownClick", function (e) {
        t.props.disabled || t.props.readOnly || (t.inputEl.focus(), "blank" === t.props.dropdownMode ? t.search(e, "", "dropdown") : "current" === t.props.dropdownMode && t.search(e, t.inputEl.value, "dropdown"), t.props.onDropdownClick && t.props.onDropdownClick({
          originalEvent: e,
          query: t.inputEl.value
        }));
      }), g(v(t), "onPaste", function (e) {
        if (t.props.allowFreeText && t.props.multiKeys !== x.defaultProps.multiKeys) {
          e.stopPropagation(), e.preventDefault();
          var o = e.clipboardData.getData("Text"),
            i = "[";
          t.props.multiKeys.forEach(function (e) {
            return i += String.fromCharCode(e);
          }), i += "]";
          var r = new RegExp(i),
            n = o.split(r),
            s = new Set();
          n.forEach(function (e) {
            var o = t.validateItem(e);
            o && s.add(o);
          }), t.selectMultipleItems(e, Array.from(s));
        }
      }), g(v(t), "selectMultipleItems", function (e, o) {
        var i;
        t.inputEl.value = "", i = t.props.value && Array.isArray(t.props.value) ? w(t.props.value).concat(w(o)) : o, t.updateModel(e, i), t.props.onSelect && t.props.onSelect({
          originalEvent: e,
          value: o
        }), t.inputEl.focus(), t.hideOverlay();
      }), g(v(t), "validateItem", function (e) {
        var o, i, r, n, s;
        return e.trim() ? !t.props.onValidateFreeText || (null === (o = (i = t.props).onValidateFreeText) || void 0 === o ? void 0 : o.call(i, e)) ? g({}, t.props.field, e) : (null === (r = (n = t.props).onValidateFreeText) || void 0 === r ? void 0 : r.call(n, e)) || !t.props.allowInvalidFreeText ? void 0 : (g(s = {}, t.props.field, e), g(s, "invalidTag", !0), s) : void 0;
      }), g(v(t), "onInputKeyDown", function (e) {
        if (t.state.overlayVisible) {
          var o = a.findSingle(t.overlay.itemsWrapper, "li.autocomplete__item--highlight");
          switch (e.which) {
            case 40:
              if (o) {
                var i = o.nextElementSibling;
                i && (a.addClass(i, "autocomplete__item--highlight"), a.removeClass(o, "autocomplete__item--highlight"), a.scrollInView(t.overlay.itemsWrapper, i));
              } else a.addClass(t.overlay.itemsWrapper.firstChild.firstChild, "autocomplete__item--highlight");
              e.preventDefault();
              break;
            case 38:
              if (o) {
                var r = o.previousElementSibling;
                r && (a.addClass(r, "autocomplete__item--highlight"), a.removeClass(o, "autocomplete__item--highlight"), a.scrollInView(t.overlay.itemsWrapper, r));
              }
              e.preventDefault();
              break;
            case 13:
              o && (t.selectItem(e, t.props.suggestions[a.index(o)]), t.hideOverlay()), e.preventDefault();
              break;
            case 27:
              t.hideOverlay(), e.preventDefault();
              break;
            case 9:
              o && t.selectItem(e, t.props.suggestions[a.index(o)]), t.hideOverlay();
          }
        } else if (t.props.allowFreeText && t.props.multiple && t.props.multiKeys.includes(e.which)) {
          var n = e.target.value,
            s = t.validateItem(n);
          n && e.preventDefault(), s && t.selectItem(e, s);
        }
        if (t.props.multiple && 8 === e.which && Array.isArray(t.props.value) && !t.inputEl.value) {
          var l = t.props.value[t.props.value.length - 1],
            p = t.props.value.slice(0, -1);
          t.updateModel(e, p), t.props.onUnselect && t.props.onUnselect({
            originalEvent: e,
            value: l
          });
        }
      }), g(v(t), "onInputFocus", function (e) {
        e.persist(), t.setState({
          focused: !0
        }, function () {
          t.props.onFocus && t.props.onFocus(e);
        });
      }), g(v(t), "onInputBlur", function (e) {
        e.persist(), t.setState({
          focused: !1
        }, function () {
          t.props.onBlur && t.props.onBlur(e);
        });
      }), g(v(t), "onMultiContainerClick", function (e) {
        t.inputEl.focus(), t.props.onClick && t.props.onClick(e);
      }), g(v(t), "onMultiInputFocus", function (e) {
        t.onInputFocus(e);
      }), g(v(t), "onMultiInputBlur", function (e) {
        t.onInputBlur(e);
      }), t.id = t.props.id || c(), t.listId = t.id + "_list", t;
    }
    return E = [{
      key: "search",
      value: function value(e, t, o) {
        null != t && ("input" !== o || 0 !== t.trim().length) && this.props.completeMethod && (this.setState({
          searching: !0
        }), this.props.completeMethod({
          originalEvent: e,
          query: t
        }));
      }
    }, {
      key: "updateModel",
      value: function value(e, t) {
        this.props.onChange && this.props.onChange({
          originalEvent: e,
          value: t,
          stopPropagation: I,
          preventDefault: I,
          target: {
            name: this.props.name,
            id: this.id,
            value: t
          }
        }), this.ariaSelected = t;
      }
    }, {
      key: "formatValue",
      value: function value(e) {
        if (!e) return "";
        if (this.props.selectedItemTemplate && (this.props.multiple ? this.isSelected(e) : this.findOptionIndex(e) > -1)) return n.getJSXElement(this.props.selectedItemTemplate, e) || e;
        if (!this.props.field || "string" == typeof e) return e;
        var t = n.resolveFieldData(e, this.props.field);
        return n.isNil(t) ? e : t;
      }
    }, {
      key: "updateInputField",
      value: function value(e) {
        var t = this.formatValue(e);
        this.inputEl.value = t;
      }
    }, {
      key: "showOverlay",
      value: function value() {
        this.setState({
          overlayVisible: !0
        });
      }
    }, {
      key: "hideOverlay",
      value: function value() {
        this.setState({
          overlayVisible: !1,
          searching: !1
        });
      }
    }, {
      key: "alignOverlay",
      value: function value() {
        var e = this.props.multiple ? this.multiContainer : this.inputEl;
        this.props.appendTo ? (this.overlay.itemsWrapper.style.width = e.offsetWidth + "px", a.absolutePosition(this.overlay.itemsWrapper, e)) : a.relativePosition(this.overlay.itemsWrapper, e), this.moveVertically(this.overlay.itemsWrapper.style);
      }
    }, {
      key: "moveVertically",
      value: function value(e) {
        var t = e.transformOrigin.includes("top");
        e.transform = t ? "translateY(4px)" : "translateY(-4px)";
      }
    }, {
      key: "removeItem",
      value: function value(e, t) {
        if (this.props.value instanceof Array) {
          var o = this.props.value[t],
            i = this.props.value.filter(function (e, o) {
              return t !== o;
            });
          this.updateModel(e, i), this.props.onUnselect && this.props.onUnselect({
            originalEvent: e,
            value: o
          });
        }
      }
    }, {
      key: "isSelected",
      value: function value(e) {
        var t = !1;
        if (Array.isArray(this.props.value)) {
          for (var o = 0; o < this.props.value.length; o++) if (n.equals(this.props.value[o], e)) {
            t = !0;
            break;
          }
        }
        return t;
      }
    }, {
      key: "findOptionIndex",
      value: function value(e) {
        var t = -1;
        if (this.props.suggestions) {
          for (var o = 0; o < this.props.suggestions.length; o++) if (n.equals(e, this.props.suggestions[o])) {
            t = o;
            break;
          }
        }
        return t;
      }
    }, {
      key: "bindDocumentClickListener",
      value: function value() {
        var e = this;
        this.documentClickListener || (this.documentClickListener = function (t) {
          3 !== t.which && e.state.overlayVisible && e.overlay && e.isOutsideClicked(t) && e.hideOverlay();
        }, document.addEventListener("click", this.documentClickListener));
      }
    }, {
      key: "unbindDocumentClickListener",
      value: function value() {
        this.documentClickListener && (document.removeEventListener("click", this.documentClickListener), this.documentClickListener = null);
      }
    }, {
      key: "bindScrollListener",
      value: function value() {
        var e = this;
        this.scrollHandler || (this.scrollHandler = new d(this.container, function () {
          e.state.overlayVisible && e.hideOverlay();
        })), this.scrollHandler.bindScrollListener();
      }
    }, {
      key: "unbindScrollListener",
      value: function value() {
        this.scrollHandler && this.scrollHandler.unbindScrollListener();
      }
    }, {
      key: "bindResizeListener",
      value: function value() {
        var e = this;
        this.resizeListener || (this.resizeListener = function () {
          e.state.overlayVisible && e.hideOverlay();
        }, window.addEventListener("resize", this.resizeListener));
      }
    }, {
      key: "unbindResizeListener",
      value: function value() {
        this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
      }
    }, {
      key: "isOutsideClicked",
      value: function value(e) {
        return this.container && this.overlay && this.overlay.itemsWrapper && !this.overlay.itemsWrapper.contains(e.target) && !this.isInputClicked(e);
      }
    }, {
      key: "isInputClicked",
      value: function value(e) {
        return this.props.multiple ? e.target === this.multiContainer || this.multiContainer.contains(e.target) : e.target === this.inputEl;
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        if (this.props.autoFocus) {
          var e, t;
          null === (t = this.inputEl) || void 0 === t || null === (e = t.focus) || void 0 === e || e.call(t);
        }
        this.props.tooltip && this.renderTooltip();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        if (e.suggestions !== this.props.suggestions && this.state.searching) {
          if (this.props.suggestions && this.props.suggestions.length || this.props.footer) {
            var t;
            this.showOverlay(), (null === (t = this.overlay) || void 0 === t ? void 0 : t.itemsWrapper) && this.alignOverlay();
          } else this.hideOverlay();
          this.setState({
            searching: !1
          });
        }
        this.inputEl && !this.props.multiple && this.updateInputField(this.props.value), e.tooltip !== this.props.tooltip && (this.tooltip ? this.tooltip.updateContent(this.props.tooltip) : this.renderTooltip());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.unbindDocumentClickListener(), this.unbindResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.tooltip && (this.tooltip.destroy(), this.tooltip = null), this.timeout && clearTimeout(this.timeout);
      }
    }, {
      key: "renderTooltip",
      value: function value() {
        this.tooltip = u({
          target: this.container,
          content: this.props.tooltip,
          options: this.props.tooltipOptions
        });
      }
    }, {
      key: "renderSimpleAutoComplete",
      value: function value() {
        var t = this;
        return e.createElement(i, {
          ref: function ref(e) {
            return t.inputEl = o.findDOMNode(e);
          },
          id: this.props.inputId,
          type: this.props.type,
          name: this.props.name,
          defaultValue: this.formatValue(this.props.value),
          role: "searchbox",
          "aria-autocomplete": "list",
          "aria-controls": this.listId,
          "aria-labelledby": this.props.ariaLabelledBy,
          className: this.props.inputClassName,
          style: this.props.inputStyle,
          autoComplete: "off",
          readOnly: this.props.readOnly,
          disabled: this.props.disabled,
          placeholder: this.props.placeholder,
          size: this.props.size,
          maxLength: this.props.maxlength,
          tabIndex: this.props.tabIndex,
          onBlur: this.onInputBlur,
          onFocus: this.onInputFocus,
          onChange: this.onInputChange,
          onMouseDown: this.props.onMouseDown,
          onKeyUp: this.props.onKeyUp,
          onKeyDown: this.onInputKeyDown,
          onKeyPress: this.props.onKeyPress,
          onContextMenu: this.props.onContextMenu,
          onClick: this.props.onClick,
          onDoubleClick: this.props.onDblClick,
          autoSelect: this.props.autoSelect,
          hasError: !!this.props.errorMessage
        });
      }
    }, {
      key: "renderChips",
      value: function value() {
        var t = this;
        return this.props.value && Array.isArray(this.props.value) ? this.props.value.map(function (o, i) {
          var r = "autocomplete__token autocomplete__item--highlight";
          return "object" == typeof o && "invalidTag" in o && (r += " autocomplete__token--error"), e.createElement("div", {
            key: i + "multi-item",
            className: r
          }, e.createElement("span", {
            className: "autocomplete__token-label"
          }, t.formatValue(o)), !t.props.disabled && e.createElement(l, {
            className: "autocomplete__token-x-icon",
            name: "times",
            light: !0,
            onClick: function onClick(e) {
              return t.removeItem(e, i);
            }
          }));
        }) : null;
      }
    }, {
      key: "renderMultiInput",
      value: function value() {
        var t = this;
        return e.createElement("div", {
          className: r("autocomplete__input-token", this.props.disabled && "autocomplete__input-token--disabled")
        }, e.createElement("input", {
          ref: function ref(e) {
            return t.inputEl = e;
          },
          type: this.props.type,
          disabled: this.props.disabled,
          placeholder: this.props.placeholder,
          role: "searchbox",
          "aria-autocomplete": "list",
          "aria-controls": this.listId,
          "aria-labelledby": this.props.ariaLabelledBy,
          autoComplete: "off",
          tabIndex: this.props.tabIndex,
          onChange: this.onInputChange,
          onPaste: this.onPaste,
          id: this.props.inputId,
          name: this.props.name,
          style: this.props.inputStyle,
          className: this.props.inputClassName,
          maxLength: this.props.maxlength,
          onKeyUp: this.props.onKeyUp,
          onKeyDown: this.onInputKeyDown,
          onKeyPress: this.props.onKeyPress,
          onFocus: this.onMultiInputFocus,
          onBlur: this.onMultiInputBlur
        }));
      }
    }, {
      key: "renderMultipleAutoComplete",
      value: function value() {
        var t,
          o = this,
          i = r("autocomplete__multiple-container", {
            "autocomplete__multiple-container--disabled": this.props.disabled,
            "autocomplete__multiple-container--empty": !(null === (t = this.props.value) || void 0 === t ? void 0 : t.length)
          }),
          n = this.renderChips(),
          s = this.renderMultiInput();
        return e.createElement("div", {
          ref: function ref(e) {
            return o.multiContainer = e;
          },
          className: i,
          onContextMenu: this.props.onContextMenu,
          onMouseDown: this.props.onMouseDown,
          onClick: this.onMultiContainerClick,
          onDoubleClick: this.props.onDblClick
        }, n, s);
      }
    }, {
      key: "renderDropdown",
      value: function value() {
        return e.createElement("div", {
          className: "autocomplete__dropdown-trigger",
          onClick: this.onDropdownClick
        }, e.createElement(l, {
          regular: !0,
          name: "angle-down",
          className: r("autocomplete__dropdown-trigger-icon", this.props.disabled && "autocomplete__dropdown-trigger-icon--disabled", this.props.readOnly && "autocomplete__dropdown-trigger-icon--readonly")
        }));
      }
    }, {
      key: "renderLoader",
      value: function value() {
        return this.state.searching ? e.createElement(h, {
          className: "autocomplete__spinner"
        }) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var t,
          o,
          i = this,
          n = r("kaseya-ui-autocomplete", this.props.className),
          l = r("autocomplete__wrapper", {
            "autocomplete__has-dropdown": this.props.dropdown,
            "autocomplete--error": this.props.errorMessage,
            "autocomplete--searching": this.state.searching,
            "autocomplete--readonly": this.props.readOnly
          }),
          a = this.renderLoader();
        return t = this.props.multiple ? this.renderMultipleAutoComplete() : this.renderSimpleAutoComplete(), this.props.dropdown && (o = this.renderDropdown()), e.createElement(s, C(k({}, this.props.containerAttributes), {
          className: n,
          value: this.props.label,
          errorMessage: this.props.errorMessage,
          isRequired: this.props.required
        }), e.createElement("span", {
          ref: function ref(e) {
            return i.container = e;
          },
          "aria-haspopup": "listbox",
          "aria-expanded": this.state.overlayVisible,
          "aria-owns": this.listId,
          className: l
        }, o, t, a, e.createElement(m, {
          in: this.state.overlayVisible,
          timeout: {
            enter: 120,
            exit: 100
          },
          unmountOnExit: !0,
          onEnter: this.onOverlayEnter,
          onEntered: this.onOverlayEntered,
          onExit: this.onOverlayExit
        }, e.createElement(p, C(k({}, this.props.panelContainerAttributes), {
          ref: function ref(e) {
            return i.overlay = e;
          },
          suggestions: this.props.suggestions,
          field: this.props.field,
          listId: this.listId,
          appendTo: this.props.appendTo,
          itemTemplate: this.props.itemTemplate,
          onItemClick: this.selectItem,
          ariaSelected: this.ariaSelected,
          panelStyle: this.props.panelStyle,
          panelClassName: this.props.panelClassName,
          scrollHeight: this.props.scrollHeight,
          footer: this.props.footer
        })))));
      }
    }], y(x.prototype, E), _ && y(x, _), x;
  }(t);
g(E, "defaultProps", {
  type: "text",
  scrollHeight: "200px",
  dropdown: !1,
  dropdownMode: "blank",
  multiple: !1,
  minLength: 1,
  delay: 300,
  readOnly: !1,
  disabled: !1,
  autoFocus: !1,
  multiKeys: [9, 13],
  required: !1,
  allowFreeText: !1,
  autoSelect: !1
});
export { E as AutoComplete };